import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";
import {
  mockGetCallbackSapInfo,
  mockSendCallbackSap,
} from "./mock/callbackSapMock";

/**
 * API callback về SAP.
 *
 * Endpoint thật do BE cung cấp:
 *  - GET  {API_MSP}/invoice-pos/callback-sap-info/{invoice_id}
 *  - POST {API_MSP}/invoice-pos/callback-sap/{invoice_id}   body: { refno }
 *
 * Đặt USE_MOCK = true để chạy dữ liệu giả (khi BE chưa deploy).
 * Khi đã chốt hẳn: xóa import mock ở trên và file services/mock/callbackSapMock.js
 */
const USE_MOCK = false;

const callbackSapService = {};

// Lấy thông tin hiển thị trên modal gửi callback về SAP
// `row` chỉ phục vụ mock, API thật chỉ cần id
callbackSapService.getCallbackSapInfo = function ({ id, row }) {
  if (USE_MOCK) {
    return mockGetCallbackSapInfo({ id, row });
  }

  return fetch({
    url: `${env.API_MSP}/invoice-pos/callback-sap-info/${id}`,
    method: "get",
  });
};

// Gửi callback về SAP
callbackSapService.sendCallbackSap = function ({ id, refno }) {
  if (USE_MOCK) {
    return mockSendCallbackSap({ id, refno });
  }

  return fetch({
    url: `${env.API_MSP}/invoice-pos/callback-sap/${id}`,
    method: "post",
    data: {
      refno,
    },
  });
};

export default callbackSapService;
